import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';

import {
  DuplicateProjectEditorFormValues,
  FORM_LAYOUT,
  getFormFields,
  validateForm,
} from './config';

function Editor({
  setFormikSubmit,
  onSubmit,
  initialValues,
}: {
  setFormikSubmit: FormProps<DuplicateProjectEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<DuplicateProjectEditorFormValues>['onSubmit'];
  initialValues: DuplicateProjectEditorFormValues;
}) {
  const { t } = useTranslation(['Admin', 'Task']);

  return (
    <Form<DuplicateProjectEditorFormValues>
      fields={getFormFields(t)}
      formName="DuplicateProjectEditor"
      initialValues={initialValues}
      layout={FORM_LAYOUT}
      setSubmitRef={setFormikSubmit}
      validate={validateForm(t)}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
